<div class="color">
    <div class="color__dot" [ngStyle]="{'background-color': color}"></div>
    <div class="color__name"><ng-content></ng-content></div>
</div>
